import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";

export const FolderList = ({lists}) => {
    return (
        <List sx={{width: '100%', margin: "16px 0", maxWidth: 360, bgcolor: 'background.paper'}}>
            {lists.map(({icon, primary, secondary}, i) => (
                <ListItem key={i} disablePadding={true}>
                    <ListItemAvatar><Avatar>{icon}</Avatar></ListItemAvatar>
                    <ListItemText primary={primary} secondary={secondary}/>
                </ListItem>
            ))}
        </List>
    );
}
